import React from 'react';
import { initializeIcons } from '@uifabric/icons';
import { withTranslation, WithTranslation } from 'react-i18next';
import { ProductCatalogueFilter } from '../../../types/corporateProductCatalogue';
import { ShortCutPaneComponent } from './component';
import {
  FilterItem,
  ShortCutPaneItem,
} from '../../../types/projectBreakdownStructure';
import history from '../../../history';
import { messageService } from '../../../services/messageService';
import {
  InstructionRegisterListPaneFilter,
  InstructionRegisterShortCutPaneItem,
} from '../../../types/instructionRegister';
import { getContractingUnit, getProject } from '../../../shared/util';

initializeIcons();

interface Props extends WithTranslation {
  shortCutPaneFilters: InstructionRegisterShortCutPaneItem[];
  handelShortCutPaneFilter: (
    selectedItem: InstructionRegisterShortCutPaneItem
  ) => void;
  filter: InstructionRegisterListPaneFilter;
  projectId: string | null;
  toggleOverlay: boolean;
  resetLayout: boolean;
  isExpand: boolean;
}

interface State {
  divClass: string;
  selectedCodeType: number;
  currentActiveSection: string | null;
}

class ShortCutPane extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      divClass: 'filter-panel-left',
      selectedCodeType: -1,
      currentActiveSection: null,
    };
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (this.props.toggleOverlay !== prevProps.toggleOverlay) {
      if (this.props.toggleOverlay) {
        this.setState({ divClass: 'filter-panel-left panel-move' });
      } else {
        this.setState({ divClass: 'filter-panel-left' });
      }
    }
    // if(this.props.resetLayout !==prevProps.resetLayout){
    //   if(this.props.resetLayout){
    //     this.setState({ divClass: 'filter-panel-left' });
    //   }
    // }
  }

  private handelShortCutPaneFilter = (
    selectedItem: InstructionRegisterShortCutPaneItem
  ) => {
    this.setState({
      currentActiveSection: selectedItem.id,
    });
    let filter: InstructionRegisterListPaneFilter =
      new InstructionRegisterListPaneFilter();

    history.push({
      pathname: `/CU/${getContractingUnit()}/project/${getProject()}/cu-instruction-register`,
      state: { irFilter: filter },
    });
    messageService.sendMessage({
      irFilter: filter,
    });
    this.props.handelShortCutPaneFilter(selectedItem);
  };

  private resetFilter = () => {
    let filterItem: InstructionRegisterShortCutPaneItem = {
      key: null,
      id: null,
      type: null,
      name: 'All',
      value: null,
    };
    this.setState({
      currentActiveSection: null,
    });

    this.props.handelShortCutPaneFilter(filterItem);
  };

  public render(): JSX.Element {
    return (
      <ShortCutPaneComponent
        currentActiveSection={this.state.currentActiveSection}
        toggleOverlay={this._toggleOverlay}
        shortCutPaneFilters={this.props.shortCutPaneFilters}
        toggleOverlayFwd={this._toggleOverlayFwd}
        handelShortCutPaneFilter={(
          selectedItem: InstructionRegisterShortCutPaneItem
        ) => this.handelShortCutPaneFilter(selectedItem)}
        resetFilter={() => this.resetFilter()}
        divClass={this.state.divClass}
        // isExpand={this.props.isExpand}
        // isCollapse={this.state.isCollapse}
      />
    );
  }

  private _toggleOverlay = (): void => {
    this.setState({
      divClass: 'filter-panel-left panel-move',
      // isCollapse: true,
    });
    messageService.sendMessage({ shortCutPaneExpanded: false });
  };
  private _toggleOverlayFwd = (): void => {
    this.setState({ divClass: 'filter-panel-left',});
    messageService.sendMessage({ shortCutPaneExpanded: true });
  };
}

export default withTranslation()(ShortCutPane);
